import reducer from 'bundles/tasks/workflows/editor/store/workflow/reducer';

export { prepareWorkflow } from 'bundles/tasks/workflows/editor/store/workflow/reducer';

export default reducer;
